import { render, staticRenderFns } from "./ThemesControl.vue?vue&type=template&id=9c38b4f0&scoped=true&"
import script from "./ThemesControl.js?vue&type=script&lang=js&"
export * from "./ThemesControl.js?vue&type=script&lang=js&"
import style0 from "./ThemesControl.scss?vue&type=style&index=0&id=9c38b4f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c38b4f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabItem,VTabs,VTabsItems})
